module.exports = __webpack_public_path__ + "static/media/image_68.3cdd8a27.png";